import { FC, useEffect } from 'react';
import { doctrineAnalytics } from '../utils/analyticsUtils';
import { getParametersFromUrl } from '../utils/url-utils/urlUtils';
import { getPageName } from '../utils/pageName';

type Props = {
  data?: { [k: string]: any };
  pageName?: string;
};

export const PageTrackOnLoad: FC<Props> = ({
  data = {},
  pageName = getPageName(),
}) => {
  useEffect(() => {
    const params = { ...data };
    const urlParams = getParametersFromUrl(window.location.search);
    params.source = urlParams.source || null;
    params.original_query_key = urlParams.originalQueryKey;
    doctrineAnalytics(`Static ${pageName}Loaded`, params);
  }, []);

  return null;
};
